import { formatSlug } from '@/fields/slug/formatSlug'
import type { JobOffer } from '@/payload-types'

export function getJobHref(job: JobOffer, locale: 'en' | 'cs'): string {
  const slugValue = job.slug

  if (typeof slugValue === 'string' && slugValue.length > 0) {
    return `/jobs/${encodeURIComponent(slugValue)}`
  } else if (typeof slugValue === 'object' && slugValue !== null) {
    const localizedSlug = (slugValue as any)[locale]
    if (typeof localizedSlug === 'string' && localizedSlug.length > 0) {
      return `/jobs/${encodeURIComponent(localizedSlug)}`
    }
  }

  if (job.title && typeof job.title === 'string') {
    const generatedSlug = formatSlug(job.title)
    return `/jobs/${encodeURIComponent(generatedSlug)}`
  }

  return '/jobs/'
}
